import { IRole } from './role';
import { ITag } from './tag';

export interface IUser {
  askNewPIN?: boolean;
  badge?: any;
  customFields?: any;
  defaultCostCenters?: any;
  defaultLanguage?: any;
  email?: any;
  firstName?: string;
  healthStatus?: any;
  imageUrl?: any;
  inactive?: boolean;
  inviteStatus?: any;
  jobTitle?: string;
  lastName?: string;
  loginDisabled?: false;
  orgAccess?: any;
  orgId?: any;
  orgName?: any;
  partnerId?: any;
  roles?: IRole[];
  supervisorId?: any;
  supervisorName?: any;
  supervisor?: any;
  tags?: ITag[];
  updatedDate?: string;
  profileId?: string;
  userType?: any;
  userVendingId?: any;
  vendingPin?: any;
  _id?: any;
  phoneNumber?: string;
  fullName?: string;
  pinExpirationDate?: string;
  comments?: string;
  costCenterValues?: any[];
}

export interface UserDTO {
  defaultLanguage?: string;
  fullName: string;
  email: string;
  imageUrl?: string;
  userId: string;
  orgId: string;
  orgName: string;
  rootOrgId: string;
  roles: any[];
  permissions: any[];
  orgPermissions: string[];
  orgAccess: string[];
  profileId?: string;
  isDistributor?: boolean;
  isAdmin?: boolean;
  isOwner?: boolean;
}

export enum UserRoles {
  Admin = 'Admin',
  Owner = 'Account Owner',
  Vending = 'Vending',
}

export interface EmbedUser {
  profileId: string;
  name: string;
  _id: string;
}
